enum DiagnosticType {
  COMMENT = 1,
  COMPLAINT = 10,
  OBSERVATION = 11,
  DIAGNOSIS = 20,
  ADVICE = 30,
  REPAIR = 31,
  RESULT = 45,
  PARTS_TO_STOCK = 50,
  REVIEW = 60,
  TEXT = 100,
  BOOLEAN = 110
}

export const COMMENT_DIAGNOSTIC_TYPES = [DiagnosticType.TEXT, DiagnosticType.COMMENT, DiagnosticType.REPAIR];

export default DiagnosticType;